import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxModal = styled(Box)(
    ({ theme }: ParamsStyle) => `
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: white;
        transform: translate(-50%, -50%);
        box-shadow: rgb(0 0 0 / 20%) 0px 11px 15px -7px, rgb(0 0 0 / 14%) 0px 24px 38px 3px, rgb(0 0 0 / 12%) 0px 9px 46px 8px;
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: 1rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }

    &.dark {
        color: ${theme?.palette.primary.main};
        border: 2px solid ${theme?.palette.primary.main};
    }
`);